const ISO_SUBDIVISION_PATTERN = /^[A-Z]{2}-[A-Z0-9]{1,10}$/;
const BARE_BRAZILIAN_UF_PATTERN = /^[A-Z]{2}$/;
/**
 * Yggy and patient declarations carry the bare 2-letter UF (e.g. "BA"); the rest
 * of the system speaks ISO-3166-2 ("BR-BA"). Normalize at the integration boundary
 * so consumers never need to know about the upstream shape.
 */
export const normalizeIsoSubdivision = (value) => {
    if (value == null)
        return null;
    const upper = value.trim().toUpperCase();
    if (!upper)
        return null;
    if (ISO_SUBDIVISION_PATTERN.test(upper))
        return upper;
    if (BARE_BRAZILIAN_UF_PATTERN.test(upper))
        return `BR-${upper}`;
    return null;
};
//# sourceMappingURL=normalize-iso-subdivision.js.map